(() => {
  const STYLE_ID = 'AdwoaSoldOutCardStyles';

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .product-grid-container .product-card-wrapper.adwoa-card-sold-out .card__badge {
        display: none !important;
      }

      .product-grid-container .product-card-wrapper.adwoa-card-sold-out .adwoa-sold-out-price {
        color: inherit;
        font: inherit;
        letter-spacing: inherit;
        text-transform: uppercase;
      }
    `;
    document.head.appendChild(style);
  }

  const soldOutTextForCard = (card) => {
    const badge = Array.from(card.querySelectorAll('.card__badge .badge')).find((item) =>
      /sold\s*out/i.test(item.textContent || '')
    );
    return badge?.textContent.trim() || 'SOLD OUT';
  };

  const patchCard = (card) => {
    const soldOutPrice = card.querySelector('.price.price--sold-out');
    if (!soldOutPrice) return;

    card.classList.add('adwoa-card-sold-out');
    const soldOutText = soldOutTextForCard(card);

    card.querySelectorAll('.card__badge').forEach((container) => {
      const hasSoldOutBadge = Array.from(container.querySelectorAll('.badge')).some((badge) =>
        /sold\s*out/i.test(badge.textContent || '')
      );
      if (hasSoldOutBadge) container.remove();
    });

    const priceContainer = soldOutPrice.querySelector('.price__container');
    if (!priceContainer || priceContainer.dataset.adwoaSoldOutPrice === 'true') return;

    const label = document.createElement('span');
    label.className = 'price-item price-item--regular adwoa-sold-out-price';
    label.textContent = soldOutText;

    priceContainer.replaceChildren(label);
    priceContainer.dataset.adwoaSoldOutPrice = 'true';
    soldOutPrice.setAttribute('aria-label', soldOutText);
  };

  const patchCards = (root = document) => {
    root.querySelectorAll?.('.product-card-wrapper').forEach(patchCard);
  };

  const start = () => {
    patchCards();

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        patchCards();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
